<template>
  <div>
    <div class="sayfahead">
      <h1>{{ Sayfa.Adi }}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">

        <el-button type="success" size="small" class="YeniBtn" @click="Excel"
                   icon="el-icon-download">Excel İndir
        </el-button>
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <el-row :gutter="24">
        <div class="raporbloksabitle">
          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="4">
              <el-form-item label="Bina" prop="Bina_id">
                <el-select @change="KisiGetir()" v-model="Form.Bina_id" filterable>
                  <el-option
                    v-for="item in Binalar"
                    :key="item.id"
                    :label="item.Adi"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item class="Tooltip" label="Kişiler" prop="Kisi_id">
                <el-tooltip class="item" effect="dark"
                            content="Boş bırakılırsa bütün binayı çeker"
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-cascader
                  collapse-tags
                  :props="{ multiple: true}"
                  :options="Kisiler"
                  v-model="Form.Kisi_id"
                  filterable clearable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item class="Tooltip" label="Borç" prop="Borc">
                <el-tooltip class="item" effect="dark"
                            content="Kişilerin sadece borçlarını gösterir"
                            placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Borc"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="4" :offset="3">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>

        </div>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <KisiEkstre :data="data" v-if="compTur===1"></KisiEkstre>
          <KisiBorcEkstre :data="data" v-if="compTur===2"></KisiBorcEkstre>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));

import Yukleniyor from "../../components/Doc/Yukleniyor";
import RaporlamaKisiEkstre from "../../components/Pack/Raporlama/RaporlamaKisiEkstre";
import KisiEkstre from "./kisi/KisiEkstre";
import KisiBorcEkstre from "./kisi/KisiBorcEkstre";

export default {
  components: {KisiBorcEkstre, KisiEkstre, RaporlamaKisiEkstre, Yukleniyor},
  data() {
    return {
      Height: 0,
      FiltreCollapse: '1',
      lo: false,
      Yetki: false,
      Kaydet: false,
      Sayfa: {
        Adi: 'Kişi Ekstresi',
        ButtonAdi: 'Uygula',
        FiltreAdi: 'Filtreleme',
      },
      Form: {
        Bina_id: null,
        Tarih: [],
        Kisi_id: null,
        Borc: false,
      },
      FormHata: {
        Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
      },
      RaporAdi: "",
      Kisiler: [],
      Binalar: [],
      data: [],
      ExcelData: [],
      tableDisplay: false,
      AltToplam: 0,
      compTur: null

    }
  },
  methods: {
    Excel(evt) {
      const wb = XLSX.utils.book_new();
      wb.Props = {
        Title: this.Sayfa.Adi,
        Author: "Aidatim APP",
        Manager: "Aidatim APP",
        Company: "Aidatim",
        Category: "Finans",
        Keywords: "Aidatim",
        Comments: this.Sayfa.Adi,
      };

      for (var prop in this.data) {
        if (this.data[prop].Excel) {
          const ws = XLSX.utils.json_to_sheet(this.data[prop].Excel);
          ws['!cols'] = [
            {wch: 12},
            {wch: 15},
            {wch: 15},
            {wch: 50},
            {wch: 12},
            {wch: 12},
            {wch: 12},
            {wch: 12},
            {wch: 12},
          ];
          XLSX.utils.book_append_sheet(wb, ws, this.data[prop].Bilgi.Excel)
        }

      }
      //this.data.forEach((data, index) => {
      // const ws = XLSX.utils.json_to_sheet(this.data);
      //XLSX.utils.book_append_sheet(wb, ws, "Test");
      //}
      XLSX.writeFile(wb, this.Sayfa.Adi + ".xlsx");

    },
    Yazdir() {
      window.print();
    },
    KisiGetir() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/kisi/liste/b/' + this.Form.Bina_id})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kisiler = response.Liste
            this.lo = false;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
            this.lo = false;
          }
        });
    },
    Getir() {
      this.$refs['RaporForm'].validate((valid) => {
        if (valid) {
          this.lo = true;
          this.$store.dispatch("Post", {...this.Form, path: 'raporlama/kisi/'})
            .then(response => {
              this.lo = false;
              if (response.Durum == "OK") {
                this.compTur = this.Form.Borc ? 2 : 1;
                this.data = response.Data;
                this.ExcelData = response.ExcelData;
                this.Height = window.innerHeight - 280
                this.tableDisplay = true
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            })
        }
      })
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
        .then(response => {
          this.lo = false;
          if (response.Durum === 'OK') {
            this.Binalar = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
  },
  created() {
    this.SayfaYukle();
    this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    if (this.$store.getters.BinaBilgi) {
      this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      this.KisiGetir();
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/pages/Raporlama/kisihesap.vue